import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { getErrorModuleStatus, refIsRequiredError } from "@util/utils";
import { Box, Card, CheckboxField } from "@curves/ui-base";
import { isValidDate, parseDate } from "@util/moment";
import { Grid } from "@mui/material";
import { SignBox } from "@icoach/components";

const TermSection = forwardRef((props, ref) => {
	// 為了漲價通知而新增的變數showPriceNotice，之後漲價通知要刪除的時候也要把showPriceNotice刪掉
	const { className, errorModule, nextShippingDate, showPriceNotice } = props;
	const confirmRef = useRef(null);
	const confirmRef2 = useRef(null);
	const confirmRef3 = useRef(null);
	// 新增漲價告知
	const confirmRef4 = useRef(null);
	const signImgRef = useRef(null);

	const getResult = () => {
		let result = {};
		if (signImgRef.current && signImgRef.current.getResult) result = Object.assign(result, { signImg: signImgRef.current.getResult() });

		return result;
	};

	useImperativeHandle(
		ref,
		() => ({
			getResult,
			isError: () => refIsRequiredError(confirmRef, confirmRef2, confirmRef3, confirmRef4, signImgRef),
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<Card className={className}>
			<Card.CardHeader title={"訂購注意事項"} className="bg-light-active text-center" />
			<Card.CardContent className="p-4">
				<Box component="ol" className="lists ol mb-3">
					<Box component="li" className="lists-item">
						開立三聯式發票者，若後續申請退貨時，需填寫【四聯折讓單】、用印公司發票章，將正本寄回本公司後，做退款申請處
						理，同意辦理時，由韻智股份有限公司代為處理發票及銷貨退回證明單，以加速退貨、退款作業。
					</Box>
					<Box component="li" className="lists-item">
						循環訂單:指訂單成立後，每月定期信用卡扣款及配送，若未辦理暫停/退訂者，仍進行扣款及配送之服務。
					</Box>
					<Box component="li" className="lists-item">
						若您已是循環訂戶，本訂單內容將與之前相同出貨週期、相同收件資訊之訂單，合併同箱出貨。
					</Box>
					<Box component="li" className="lists-item">
						每月出貨日前2-3個工作日扣款，如持卡人非訂購人，請於下方註明關係並簽名；持卡人同意依照信用卡使用規定，應按所示之金額，付款予發卡銀行。
					</Box>
					<Box component="li" className="lists-item">
						欲變更訂單資料(手機號碼、收件地址、信用卡資訊)及更換口味、盒數，須於出貨日前5天向店舖提出變更申請：「10號出貨，最晚須於當月5號前提出」，「20號出貨，最晚須於當月15號前提出」，若超過前述日期則於次月生效。
					</Box>
					<Box component="li" className="lists-item">
						首次配送之商品享有7日鑑賞期，如逾期未退回，則視為交貨完整，恕無法退換貨；非瑕疵商品拆除封膜後不接受退換貨。
					</Box>
					<Box component="li" className="lists-item">
						扣款後3個工作日內，將開立電子發票至您的電子信箱或手機簡訊或載具；開立三聯式發票者，若後續申請退貨時，需填寫【四聯折讓單】、用印公司發票章，將正本寄回本公司後做退款申請處理。
					</Box>
					<Box component="li" className="lists-item">
						本公司將不定期傳送優惠活動及相關服務資訊至您所留存的Email/手機，如需修改Email/手機，請主動告知以保障您的權利。
					</Box>
					<Box component="li" className="lists-item">
						以傳真或Email方式訂購產品時，您同意所填之影本、傳真、電子檔案內容同具法律效用。
					</Box>
				</Box>
				<Box className="bg-info-light px-4 py-2 mb-4">
					<CheckboxField label="" ref={confirmRef} required>
						<CheckboxField.Checkbox
							value={true}
							label={"我已詳細閱讀商品訂購注意事項，且同意授權每月信用卡扣款及辦理退貨時，由韻智股份有限公司代為處理發票銷貨退回證明單，以加速退貨退款作業。"}
						/>
					</CheckboxField>
				</Box>
				<Box className="bg-info-light px-4 py-2 mb-4">
					<CheckboxField label="" ref={confirmRef3} required>
						<CheckboxField.Checkbox
							value={true}
							label={"我已瞭解：馬拉松集點活動需每月皆有出貨紀錄；若任一月份未產生任何出貨紀錄(包含所有訂單暫停或退訂)，點數於下一次兌換期後歸零，實際歸零時間與細節可向教練詢問。"}
						/>
					</CheckboxField>
				</Box>
				{showPriceNotice && (
					<Box className="bg-info-light px-4 py-2 mb-4">
						<CheckboxField label="" ref={confirmRef4} required>
							<CheckboxField.Checkbox
								value={true}
								label={"本人已知悉自2026年11月起，濃縮乳清蛋白系列循環價格將調整為$1,580，分離乳清蛋白系列循環價格將調整為$1,780，其他產品維持原價。"}
							/>
						</CheckboxField>
					</Box>
				)}
				{isValidDate(nextShippingDate) && (
					<Box className="bg-info-light px-4 py-2 mb-4">
						<CheckboxField key={nextShippingDate} label="" ref={confirmRef2} required>
							<CheckboxField.Checkbox value={true} label={`預計下次出貨月份為：${parseDate(nextShippingDate, "YYYY [年] M [月]")}`} />
						</CheckboxField>
					</Box>
				)}
				<Grid spacing={3} container>
					<Grid xs={6} item>
						<SignBox ref={signImgRef} title="訂購人簽名" required {...getErrorModuleStatus(errorModule, "signImg")} />
					</Grid>
				</Grid>
			</Card.CardContent>
		</Card>
	);
});

export default TermSection;
